// @flow
/* eslint-disable arrow-body-style */
import React from 'react';
import Icon from 'components/_particles/icon/react/Icon';
import { t } from 'javascripts/utils/withTranslation';
import IconLink from 'components/atoms/icon-link/react/IconLink';
import type { Tree, Wording } from '../types';
import { printTileValue } from './Tile';

type Props = {
  rootHeight: number,
  tile: Tree,
  onClick: (tile: Tree) => void,
  variant?: 'absolute' | 'relative',
  wording?: Wording,
};

const RootTile = ({
  rootHeight,
  tile,
  onClick,
  wording,
  variant = 'absolute',
}: Props): React$MixedElement => {
  const { lang } = document.documentElement || { lang: 'de' };

  return (
    <div
      style={{ height: rootHeight }}
      key={tile.data.id}
      id={tile.data.id}
      className="tax-calculator__tile tax-calculator__root"
    >
      {tile.data.icon && (
        <Icon className="tax-calculator__icon" icon={tile.data.icon} />
      )}
      <div className="tax-calculator__currency">
        {printTileValue(tile, variant, lang) ===
        printTileValue(undefined, variant, lang)
          ? wording?.tile?.zero || t('Wert zu gering')
          : printTileValue(tile, variant, lang)}
      </div>

      <div className="tax-calculator__title-text">{tile.data.title}</div>
      <div className="tax-calculator__sub">{tile.data.text}</div>

      {tile.data.link && (
        <IconLink
          link={tile.data.link.url}
          icon="arrow-right-line"
          className="tax-calculator__link"
          external={tile.data.link.target === '_blank'}
        >
          {tile.data.link.text}
        </IconLink>
      )}

      <button
        type="button"
        onClick={onClick}
        className="button button--icon button--secondary button--small tax-calculator__toggle-button"
      >
        <Icon icon="bw-cross-large-line" />
        <span className="u-hidden-visually">{t('Eine Ebene höher gehen')}</span>
      </button>
    </div>
  );
};

export default RootTile;
